<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-checkbox
      v-bind="$attrs"
      :checked="value"
      :state="getValidationState(validatable, validationContext)"
      class="no-delimiter mb-1 pb-0"
      @input="emitValue"
    >
      <slot>{{ fieldLabel }}</slot>
      <slot name="desc">{{ desc }}</slot>
    </b-checkbox>
    <b-form-invalid-feedback
      v-if="validatable"
      :state="getValidationState(validatable, validationContext)"
    >
      {{ validationContext.errors[0] }}
    </b-form-invalid-feedback>
  </validation-provider>
</template>

<script>
import { baseValidatableMixin } from "@foys-tech/foys-utils";
export default {
  mixins: [baseValidatableMixin],
  props: {
    desc: {
      type: String,
      default: null,
    },
  },
};
</script>